import { AppStore } from "@/models";
import { useSelector } from "react-redux";

export const useAuth = () => {
    const stateUser = useSelector((store: AppStore) => store.user);
    
    return stateUser && stateUser.user;
}